import { useState, useEffect } from "react";
import WishToaster from "../components/WishToaster";
import useAPIs from "./useAPIs";
import { AppUtils } from "./AppUtils";

const useProfile = (distributorId, language_id) => {
  const { apiError, processing, postData, postFormData, getData } = useAPIs();
  const [profileLoading, setLoading] = useState(false);

  // Safe JSON parsing with error handling
  const getDistributorId = () => {
    try {
      const distributorData = localStorage.getItem("distributor");
      if (distributorData) {
        const parsed = JSON.parse(distributorData);
        return parsed?.distributor_id || distributorId;
      }
    } catch (error) {
      console.warn("Error parsing distributor data from localStorage:", error);
    }
    return distributorId;
  };

  const dist_id = getDistributorId();
  const payload = {
    distributor_id: dist_id,
  };

  const labelMap = {
    mverification_status_id: "Verification Status",
    coapplicant_id: "Coapplicant ID",
    coapplicant_distributor_id: "Coapplicant Direct Seller ID",
    coapplicant_name: "Coapplicant Name",
    coapplicant_phone: "Coapplicant Phone",
    coapplicant_email: "Coapplicant Email",
    coapplicant_dob: "Coapplicant Date of Birth",
    coapplicant_mgender_id: "Coapplicant Gender ID",
    coapplicant_mrelationship_id: "Coapplicant Relationship ID",
    coapplicant_pan_no: "Coapplicant PAN Number",
    coapplicant_pan_file_url: "Coapplicant PAN File",
    coapplicant_bank_name: "Coapplicant Bank Name",
    coapplicant_branch_name: "Coapplicant Branch Name",
    coapplicant_ifsc: "Coapplicant IFSC Code",
    coapplicant_account_no: "Coapplicant Account Number",
    coapplicant_account_name: "Coapplicant Account Name",
    coapplicant_bank_proof_url: "Coapplicant Bank Proof",
    coapplicant_justification_proof_url: "Coapplicant Justification Proof",
    remarks: "Remarks",
  };

  const getProfile = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-profile`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getAdvancementHistory = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/enrollment/fetch-dist-rank-journey`,
      {
        distributor_id: `${dist_id}`,
      },
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const getDistPersonalDetails = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-personal-details`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getDistContactDetails = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-contact-details`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getDistBankDetails = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-bank-details`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getDistKYC = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-kyc`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getDistCards = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-my-cards`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getCoAppProfile = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-coapp-profile`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getCoAppKYC = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-coapp-kyc`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getVotmProfile = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-votm-profile`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };
  const getPcmProfile = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-pcm-profile`, payload, (data) => {
      setLoading(false);
      onSuccess && onSuccess(data);
    });
  };

  const postEditPersonal = (editPayload, onSuccess, onError) => {
    setLoading(true);

    postData(
      `/enrollment/edit-dist-personal-details`,
      editPayload,
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const postEditComAddress = (editPayload, onSuccess, onError) => {
    setLoading(true);

    postData(
      `/enrollment/edit-dist-communication-address`,
      editPayload,
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  // Base implementation
  const postBankDetailsBase = (endpoint, editPayload, onSuccess, onError) => {
    setLoading(true);
    postFormData(
      endpoint,
      AppUtils.createFormData(editPayload),
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  // Wrapper functions (if you need to maintain the API)
  const postEditBank = (editPayload, onSuccess, onError) => {
    postBankDetailsBase(`/enrollment/vo-edit-dist-bank-details`, editPayload, onSuccess, onError);
  };
  const postReUploadCoappBank = (editPayload, onSuccess, onError) => {
    postBankDetailsBase(`/enrollment/vo-edit-coapp-bank-details`, editPayload, onSuccess, onError);
  };

  const postEditPermaAddress = (editPayload, onSuccess, onError) => {
    setLoading(true);
    postFormData(
      `/enrollment/edit-dist-permanent-address`,
      AppUtils.createFormData(editPayload),
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({ toastMessage: error, toastType: "error" });
        onError && onError(error);
      }
    );
  };
  const postEditDispName = (name, onSuccess, onError) => {
    setLoading(true);
    postData(
      `/enrollment/edit-dist-display-name`,
      {
        distributor_id: payload.distributor_id,
        display_name: name,
      },
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const postFileUploadProfile = (payload, onSuccess, onError) => {
    setLoading(true);
    postFormData(
      `/enrollment/upload-document`,
      payload,
      (data) => {
        setLoading(false);
        WishToaster({
          toastMessage: "File uploaded successfully!",
          toastType: "success",
        });
        onSuccess && onSuccess(data);
      },
      (error) => {
        console.log(error);
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong with the file upload!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const sendOTP = (flag, mpayload, onSuccess, onError) => {
    setLoading(true);
    mpayload.distributor_id = payload.distributor_id;
    postData(
      flag ? `/enrollment/send-otp-to-dist-phone` : `/enrollment/send-otp-to-dist-mail`,
      mpayload,
      (data) => {
        setLoading(false);
        WishToaster({ toastMessage: "OTP Sent!", toastType: "success" });
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const verifyOTPSave = (flag, mpayload, onSuccess, onError) => {
    setLoading(true);
    mpayload.distributor_id = payload.distributor_id;
    postData(
      flag ? `/enrollment/verify-dist-phone-otp` : `/enrollment/verify-dist-email-otp`,
      mpayload,
      (data) => {
        setLoading(false);
        WishToaster({ toastMessage: "Success!", toastType: "success" });
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const changeCoApp = (mpayload, onSuccess, onError) => {
    setLoading(true);
    mpayload.distributor_id = payload.distributor_id;
    postFormData(
      `/enrollment/change-dist-coapp`,
      AppUtils.createFormData(mpayload),
      (data) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Success! Changes will be live once approved!",
          toastType: "success",
        });
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const fetchChangeCoApp = (coAppId, onSuccess, onError) => {
    setLoading(true);
    let mpayload = {};
    mpayload.distributor_id = payload.distributor_id;
    mpayload.coapplicant_id = coAppId;
    postData(
      `/enrollment/fetch-dist-coapp-change`,
      mpayload,
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const sendOTPCoapp = (flag, mpayload, onSuccess, onError) => {
    setLoading(true);
    mpayload.distributor_id = payload.distributor_id;
    postData(
      flag ? `/enrollment/send-otp-to-coapp-phone` : `/enrollment/send-otp-to-coapp-mail`,
      mpayload,
      (data) => {
        setLoading(false);
        WishToaster({ toastMessage: "OTP Sent!", toastType: "success" });
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const verifyOTPSaveCoapp = (flag, mpayload, onSuccess, onError) => {
    setLoading(true);
    mpayload.distributor_id = payload.distributor_id;
    postData(
      flag ? `/enrollment/verify-coapp-phone-otp` : `/enrollment/verify-coapp-email-otp`,
      mpayload,
      (data) => {
        setLoading(false);
        WishToaster({ toastMessage: "Success!", toastType: "success" });
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const fetchAddressChange = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/enrollment/fetch-dist-permanent-address-change`,
      payload,
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({ toastMessage: error, toastType: "error" });
        onError && onError(error);
      }
    );
  };
  const fetchBankChange = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/enrollment/fetch-dist-bank-details-change`,
      payload,
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({ toastMessage: error, toastType: "error" });
        onError && onError(error);
      }
    );
  };
  const getBankBranchDetails = (ifscCode, onSuccess) => {
    getData(`/enrollment/fetch-bank-details?ifsc_code=${ifscCode}`, (data) => {
      onSuccess && onSuccess(data);
    });
  };
  const getIDCardData = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/enrollment/distributor-id-card`,
      {
        distributor_id: `${dist_id}`,
      },
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: error ?? "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const getWelcomeCard = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/enrollment/distributor-welcome`,
      {
        distributor_id: `${dist_id}`,
      },
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: error ?? "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const getInsuranceCard = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/reports/distributor-insurance-card`,
      {
        distributor_id: `${dist_id}`,
      },
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: error ?? "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const getCoApplicantInsuranceCard = (onSuccess, onError) => {
    setLoading(true);
    postData(
      `/reports/coapplicant-insurance-card`,
      {
        distributor_id: `${dist_id}`,
      },
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: error ?? "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const postVotmAddress = (editPayload, onSuccess, onError) => {
    setLoading(true);

    postData(
      `/enrollment/votm-update-address`,
      editPayload,
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({
          toastMessage: "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const fetchEventlist = (onSuccess) => {
    setLoading(true);

    postData(`/enrollment/fetch-dist-contact-details`, payload, (contactData) => {
      if (contactData?.communication_mstate_id) {
        const updatedPayload = {
          ...payload,
          state_id: contactData.communication_mstate_id,
          from_vo: 1,
        };

        postData(`/sales/v1/distributor-event-list`, updatedPayload, (eventData) => {
          setLoading(false);
          console.log(eventData, "eventData");

          // Include the state_id in the returned data
          onSuccess &&
            onSuccess({
              ...eventData,
              state_id: contactData.communication_mstate_id,
            });
        });
      } else {
        setLoading(false);
        onSuccess && onSuccess(null);
      }
    });
  };

  const registerEvent = (editPayload, onSuccess, onError) => {
    setLoading(true);
    postFormData(
      `/sales/v1/register-distributors-event`,
      AppUtils.createmultiFormData(editPayload),
      (data) => {
        setLoading(false);
        onSuccess && onSuccess(data);
      },
      (error) => {
        setLoading(false);
        WishToaster({ toastMessage: error, toastType: "error" });
        onError && onError(error);
      }
    );
  };

  return {
    getProfile,
    getAdvancementHistory,
    getDistPersonalDetails,
    getDistContactDetails,
    getDistBankDetails,
    getDistKYC,
    getDistCards,
    getCoAppProfile,
    getCoAppKYC,
    postEditPersonal,
    postEditComAddress,
    postEditBank,
    postReUploadCoappBank,
    getPcmProfile,
    getVotmProfile,
    postEditDispName,
    postFileUploadProfile,
    sendOTP,
    verifyOTPSave,
    changeCoApp,
    fetchChangeCoApp,
    sendOTPCoapp,
    verifyOTPSaveCoapp,
    fetchAddressChange,
    fetchBankChange,
    getBankBranchDetails,
    postEditPermaAddress,
    labelMap,
    getIDCardData,
    getWelcomeCard,
    getInsuranceCard,
    getCoApplicantInsuranceCard,
    postVotmAddress,
    fetchEventlist,
    registerEvent,
  };
};

export default useProfile;
